import { ref } from "vue";
const ratsinfoUser = ref(null);
function setRatsinfoUser(user) {
}
export { setRatsinfoUser, ratsinfoUser };
